/**
 * Puzzle-Index — sammelt alle Kategorien zu einem Pool.
 * Public API für puzzleService.js
 */
import { SEQUENCES } from './sequences.js';
import { EQUATIONS } from './equations.js';
import { LOGIC }     from './logic.js';
import { PATTERNS }  from './patterns.js';
import { VISUAL }    from './visual.js';

export const ALL_PUZZLES = [
  ...SEQUENCES,
  ...EQUATIONS,
  ...LOGIC,
  ...PATTERNS,
  ...VISUAL,
];

export const PUZZLE_CATEGORIES = {
  sequences: SEQUENCES,
  equations: EQUATIONS,
  logic:     LOGIC,
  patterns:  PATTERNS,
  visual:    VISUAL,
};

export function getRandomPuzzle() {
  return ALL_PUZZLES[Math.floor(Math.random() * ALL_PUZZLES.length)];
}

export function getPuzzleByCategory(cat) {
  const pool = PUZZLE_CATEGORIES[cat] || ALL_PUZZLES;
  return pool[Math.floor(Math.random() * pool.length)];
}

export function getPuzzleByDifficulty(diff) {
  const pool = ALL_PUZZLES.filter(p => p.diff === diff);
  return pool[Math.floor(Math.random() * pool.length)] || ALL_PUZZLES[0];
}

export function getPuzzleCount() { return ALL_PUZZLES.length; }
